export default {
    AFG: 'Afganistán',
    ALB: 'Albania',
    DEU: 'Alemania',
    AND: 'Andorra',
    AGO: 'Angola',
    AIA: 'Anguila',
    ATG: 'Antigua y Barbuda',
    ATA: 'Antártida',
    SAU: 'Arabia Saudita',
    DZA: 'Argelia',
    ARG: 'Argentina',
    ARM: 'Armenia',
    ABW: 'Aruba',
    AUS: 'Australia',
    AUT: 'Austria',
    AZE: 'Azerbaiyán',
    BHS: 'Bahamas',
    BHR: 'Bahrein',
    BGD: 'Bangladesh',
    BRB: 'Barbados',
    BLZ: 'Belice',
    BEN: 'Benin',
    BLR: 'Bielorrusia',
    BOL: 'Bolivia (Estado Plurinacional de)',
    BES: 'Bonaire, San Eustaquio y Saba',
    BIH: 'Bosnia y Herzegovina',
    BWA: 'Botsuana',
    BRA: 'Brasil',
    BRN: 'Brunei Darussalam',
    BGR: 'Bulgaria',
    BFA: 'Burkina Faso',
    BDI: 'Burundi',
    BTN: 'Bután',
    BEL: 'Bélgica',
    CPV: 'Cabo Verde',
    KHM: 'Camboya',
    CMR: 'Camerún',
    CAN: 'Canadá',
    TCD: 'Chad',
    CZE: 'Chequia',
    CHL: 'Chile',
    CHN: 'China',
    CYP: 'Chipre',
    COL: 'Colombia',
    COM: 'Comoras',
    COG: 'Congo',
    COD: 'Congo, República Democrática del',
    KOR: 'Corea, república de',
    CRI: 'Costa Rica',
    CIV: 'Costa de Marfil',
    HRV: 'Croacia',
    CUB: 'Cuba',
    CUW: 'Curazao',
    DNK: 'Dinamarca',
    DJI: 'Djibouti',
    DMA: 'Dominica',
    ECU: 'Ecuador',
    EGY: 'Egipto',
    SLV: 'El Salvador',
    ARE: 'Emiratos Árabes Unidos',
    ERI: 'Eritrea',
    SVK: 'Eslovaquia',
    SVN: 'Eslovenia',
    ESP: 'España',
    USA: 'Estados Unidos de America',
    EST: 'Estonia',
    SWZ: 'Eswatini',
    ETH: 'Etiopía',
    RUS: 'Federación Rusa',
    PHL: 'Filipinas',
    FIN: 'Finlandia',
    FJI: 'Fiyi',
    FRA: 'Francia',
    GAB: 'Gabón',
    GMB: 'Gambia',
    GEO: 'Georgia',
    SGS: 'Georgia del sur y las islas Sandwich del sur',
    GHA: 'Ghana',
    GIB: 'Gibraltar',
    GRD: 'Granada',
    GRC: 'Grecia',
    GLP: 'Guadalupe',
    GUM: 'Guam',
    GTM: 'Guatemala',
    GUY: 'Guayana',
    GUF: 'Guayana Francesa',
    GGY: 'Guernsey',
    GIN: 'Guinea',
    GNQ: 'Guinea Ecuatorial',
    GNB: 'Guinea-Bissau',
    HTI: 'Haití',
    HND: 'Honduras',
    HKG: 'Hong Kong',
    HUN: 'Hungría',
    IND: 'India',
    IDN: 'Indonesia',
    IRQ: 'Irak',
    IRL: 'Irlanda',
    IRN: 'Irán (República Islámica de)',
    BVT: 'Isla Bouvet',
    NFK: 'Isla Norfolk',
    CXR: 'Isla de Navidad',
    IMN: 'Isla del hombre',
    ISL: 'Islandia',
    ALA: 'Islas Aland',
    BMU: 'Islas Bermudas',
    CYM: 'Islas Caimán',
    CCK: 'Islas Cocos (Keeling)',
    COK: 'Islas Cook',
    FRO: 'Islas Faroe',
    HMD: 'Islas Heard y McDonald',
    FLK: 'Islas Malvinas (Falkland Islands)',
    MNP: 'Islas Marianas del Norte',
    MHL: 'Islas Marshall',
    SLB: 'Islas Salomón',
    TCA: 'Islas Turcas y Caicos',
    VIR: 'Islas Vírgenes (EE. UU.)',
    VGB: 'Islas Vírgenes Británicas',
    UMI: 'Islas ultramarinas menores de Estados Unidos',
    ISR: 'Israel',
    ITA: 'Italia',
    JAM: 'Jamaica',
    JPN: 'Japón',
    JEY: 'Jersey',
    JOR: 'Jordán',
    QAT: 'Katar',
    KAZ: 'Kazajstán',
    KEN: 'Kenia',
    KGZ: 'Kirguistán',
    KIR: 'Kiribati',
    KWT: 'Kuwait',
    LSO: 'Lesoto',
    LVA: 'Letonia',
    LBR: 'Liberia',
    LBY: 'Libia',
    LIE: 'Liechtenstein',
    LTU: 'Lituania',
    LUX: 'Luxemburgo',
    LBN: 'Líbano',
    MAC: 'Macao',
    MKD: 'Macedonia del norte',
    MDG: 'Madagascar',
    MYS: 'Malasia',
    MWI: 'Malawi',
    MDV: 'Maldivas',
    MLI: 'Mali',
    MLT: 'Malta',
    MAR: 'Marruecos',
    MTQ: 'Martinica',
    MUS: 'Mauricio',
    MRT: 'Mauritania',
    MYT: 'Mayotte',
    MEX: 'Mexico',
    FSM: 'Micronesia (Estados Federados de)',
    MDA: 'Moldavia, República de',
    MNG: 'Mongolia',
    MNE: 'Montenegro',
    MSR: 'Montserrat',
    MOZ: 'Mozambique',
    MMR: 'Myanmar',
    MCO: 'Mónaco',
    NAM: 'Namibia',
    NRU: 'Nauru',
    NPL: 'Nepal',
    NIC: 'Nicaragua',
    NGA: 'Nigeria',
    NIU: 'Niue',
    NOR: 'Noruega',
    NCL: 'Nueva Caledonia',
    NZL: 'Nueva Zelanda',
    NER: 'Níger',
    OMN: 'Omán',
    PAK: 'Pakistán',
    PLW: 'Palau',
    PSE: 'Palestina, Estado de',
    PAN: 'Panamá',
    PNG: 'Papúa Nueva Guinea',
    PRY: 'Paraguay',
    NLD: 'Países Bajos',
    PER: 'Perú',
    PCN: 'Pitcairn',
    PYF: 'Polinesia francés',
    POL: 'Polonia',
    PRT: 'Portugal',
    PRI: 'Puerto Rico',
    GBR: 'Reino Unido de Gran Bretaña e Irlanda del Norte',
    CAF: 'República Centroafricana',
    LAO: 'República Democrática Popular Lao',
    DOM: 'República Dominicana',
    PRK: 'República de Corea, Popular Democrática de)',
    SYR: 'República Árabe Siria',
    REU: 'Reunión',
    RWA: 'Ruanda',
    ROU: 'Rumania',
    ESH: 'Sahara Occidental',
    WSM: 'Samoa',
    ASM: 'Samoa Americana',
    BLM: 'San Bartolomé',
    KNA: 'San Cristóbal y Nieves',
    SMR: 'San Marino',
    MAF: 'San Martín (parte francesa)',
    SPM: 'San Pedro y Miquelón',
    VCT: 'San Vicente y las Granadinas',
    SHN: 'Santa Elena, Ascensión y Tristán de Cunha',
    LCA: 'Santa Lucía',
    VAT: 'Santa Sede',
    STP: 'Santo Tomé y Príncipe',
    SEN: 'Senegal',
    SRB: 'Serbia',
    SYC: 'Seychelles',
    SLE: 'Sierra Leona',
    SGP: 'Singapur',
    SXM: 'Sint Maarten (parte holandesa)',
    SOM: 'Somalia',
    LKA: 'Sri Lanka',
    ZAF: 'Sudáfrica',
    SDN: 'Sudán',
    SSD: 'Sudán del Sur',
    SWE: 'Suecia',
    CHE: 'Suiza',
    SUR: 'Surinam',
    SJM: 'Svalbard y Jan Mayen',
    THA: 'Tailandia',
    TWN: 'Taiwan, provincia de China',
    TZA: 'Tanzania, República Unida de',
    TJK: 'Tayikistán',
    IOT: 'Territorio Británico del Océano Índico',
    ATF: 'Territorios Franceses del Sur',
    GRL: 'Tierra Verde',
    TLS: 'Timor-Leste',
    TGO: 'Togo',
    TKL: 'Tokelau',
    TON: 'Tonga',
    TTO: 'Trinidad y Tobago',
    TKM: 'Turkmenistán',
    TUR: 'Turquía',
    TUV: 'Tuvalu',
    TUN: 'Túnez',
    UKR: 'Ucrania',
    UGA: 'Uganda',
    URY: 'Uruguay',
    UZB: 'Uzbekistán',
    VUT: 'Vanuatu',
    VEN: 'Venezuela (República Bolivariana de)',
    VNM: 'Viet Nam',
    WLF: 'Wallis y Futuna',
    YEM: 'Yemen',
    ZMB: 'Zambia',
    ZWE: 'Zimbabue',
    null: '-',
    "-": '-'
};
